import React from 'react';
import { useSelector } from 'react-redux';
import { SelectField } from 'components';
import { FormControl } from '@mui/material';
import { OPTIONS, MENU_ITEMS_CONFIG } from './Constants';

// Non-breaking spaces so the indentation actually renders under each group header
// (regular leading spaces get collapsed by HTML/CSS whitespace normalization and
// end up flush-left, which is why the items looked un-indented under "VMO2 Ran" /
// "VMO2 Radio Design").
const INDENT = '\u00A0\u00A0\u00A0\u00A0';

const OptionSelector = ({ onChange, value }) => {
	const role = useSelector(state => state.session.user.role);
	const projects = useSelector(state => state.session.user.projects);

	const hasItemAccess = (item) => {
		const hasRole = item.allowedRoles.includes(role);
		const hasProject = Array.isArray(projects) && projects.some(p => item.allowedProjects.includes(p));
		return hasRole && hasProject;
	};

	const visibleItems = MENU_ITEMS_CONFIG.filter(hasItemAccess);

	// Group visible items by project
	const grouped = visibleItems.reduce((acc, item) => {
		if (!acc[item.project]) acc[item.project] = [];
		acc[item.project].push(item);
		return acc;
	}, {});

	// Build menuItems with subheaders injected as non-selectable items. Headers are
	// upper-cased and wrapped with a thin rule so they read as section titles instead
	// of looking like just another (disabled) option; real options are indented under
	// their header with non-breaking spaces.
	const menuItems = [
		{ value: OPTIONS.NONE, disabled: true, text: 'Select one option' },
		...Object.entries(grouped).flatMap(([projectName, items]) => [
			{ value: `__header__${projectName}`, disabled: true, text: `\u2500\u2500 ${projectName.toUpperCase()} \u2500\u2500`, isHeader: true },
			...items.map(item => ({ value: item.value, disabled: false, text: `${INDENT}${item.text}` })),
		]),
	];

	return (
		<FormControl fullWidth>
			<SelectField
				id="inputType"
				name="inputType"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				hintText="Option"
				menuItems={menuItems}
			/>
		</FormControl>
	);
};

export default OptionSelector;